module.exports = __webpack_public_path__ + "img/lamzing-if-you-like-pina-coladas.547f61c3.png";